import { render, staticRenderFns } from "./ActivityItemApproval.vue?vue&type=template&id=5bc657e2"
import script from "./ActivityItemApproval.vue?vue&type=script&lang=js"
export * from "./ActivityItemApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc657e2')) {
      api.createRecord('5bc657e2', component.options)
    } else {
      api.reload('5bc657e2', component.options)
    }
    module.hot.accept("./ActivityItemApproval.vue?vue&type=template&id=5bc657e2", function () {
      api.rerender('5bc657e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/ActivityItemApproval.vue"
export default component.exports